<template>
  <div>
    <h1>{{ item && item['title'] }}</h1>

    <b-button class="btn btn-info btn-lg" v-b-modal.myModal>Otwórz Modal</b-button>
    <!-- Modal -->
    <b-modal id="myModal" title="Modal testowy" hide-footer>
      <div>Przykładowa wiadomość</div>
    </b-modal>

  <b-card>
  <div>
    <div
      v-if="isLoading"
      class="alert alert-info"
      role="status">Loading...</div>
    <div
      v-if="error"
      class="alert alert-danger"
      role="alert">
      <span
        class="fa fa-exclamation-triangle"
        aria-hidden="true" /> {{ error }}
    </div>
    <div
      v-if="deleteError"
      class="alert alert-danger"
      role="alert">
      <span
        class="fa fa-exclamation-triangle"
        aria-hidden="true" /> {{ deleteError }}
    </div>
    </div>
    <b-row v-if="item">
      <b-col cols="12" lg="3">
            <label>state - </label>
            <strong> {{ item['version'] }}</strong>
      </b-col>
      <b-col cols="12" lg="3">
         <label>catId - </label>
         <strong> {{ item['catId'] }}</strong>
      </b-col>
      <b-col cols="12" lg="3">
          <label>{{$t('views.documenttype.list.title')}} - </label>
          <strong> {{ item['title'] }}</strong>
      </b-col>
      <b-col cols="12" lg="3">
          <label>{{$t('views.documenttype.list.subtitle')}} - </label>
          <strong> {{ item['subtitle'] }}</strong>
      </b-col>
      <b-col cols="12" lg="3">
          <label>{{$t('views.documenttype.list.language')}} -</label>
          <strong> {{ item['language'] }}</strong>
      </b-col>
      <b-col cols="12" lg="3">
          <label>{{$t('views.documenttype.list.version')}} -</label>
          <strong> {{ item['version'] }}</strong>
      </b-col>
      <b-col cols="12" lg="6">
        <label> {{$t('views.documenttype.list.specialInfo')}} - </label>
        <strong> {{ item['specialInfo'] }}</strong>
      </b-col>
    </b-row>

  </b-card>
    <router-link
      v-if="item"
      :to="{ name: 'DocumentTypeList' }"
      class="btn btn-default">{{$t('buttons.backToList')}}</router-link>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {

  computed: mapGetters({
    deleteError: 'documenttype/del/error',
    error: 'documenttype/show/error',
    isLoading: 'documenttype/show/isLoading',
    item: 'documenttype/show/retrieved'
  }),

  beforeDestroy () {
    this.reset()
  },

  created () {
    this.retrieve(decodeURIComponent(this.$route.params.id))
  },

  methods: {
    ...mapActions({
      del: 'documenttype/del/del',
      reset: 'documenttype/show/reset',
      retrieve: 'documenttype/show/retrieve'
    }),

    deleteItem (item) {
      if (window.confirm('Are you sure you want to delete this item?')) {
        this.del(item).then(() => this.$router.push({ name: 'DocumentTypeList' }))
      }
    }
  }
}
</script>
